import { DateTime } from 'luxon';

export default function dateIsSameMonth(date: DateTime, date2: DateTime) {
  return date.month === date2.month;
}
